module.exports = __webpack_public_path__ + "img/82.7e162054.jpg";